export function createDefaultVaultState() {
    return {
        id: null,
        title: '',
        owner: '',
        owner_avatar: '',
        owner_email: '',
        owner_phone: '',
        description: '',
        reader_ids: [],
        customer_ids: [],
        guest_ids: [],
        readers: [],
        customers: [],
        guests: [],
        can_edit: false,
        can_delete: false,
        can_manage_details: false,
        can_manage_permissions: false,
        active_secure_share: null,
        updated_at: null,
        last_access_at: null,
    };
}

export function normalizeVaultState(vault = {}, currentVault = {}) {
    return {
        ...createDefaultVaultState(),
        ...currentVault,
        id: vault.id || null,
        title: vault.title || currentVault.title || '',
        owner: vault.owner || currentVault.owner || '-',
        owner_avatar: vault.owner_avatar || currentVault.owner_avatar || '',
        owner_email: vault.owner_email || currentVault.owner_email || '',
        owner_phone: vault.owner_phone || currentVault.owner_phone || '',
        description: vault.description || '',
        reader_ids: Array.isArray(vault.reader_ids) ? vault.reader_ids : (currentVault.reader_ids || []),
        customer_ids: Array.isArray(vault.customer_ids) ? vault.customer_ids : (currentVault.customer_ids || []),
        guest_ids: Array.isArray(vault.guest_ids) ? vault.guest_ids : (currentVault.guest_ids || []),
        readers: Array.isArray(vault.readers) ? vault.readers : (currentVault.readers || []),
        customers: Array.isArray(vault.customers) ? vault.customers : (currentVault.customers || []),
        guests: Array.isArray(vault.guests) ? vault.guests : (currentVault.guests || []),
        can_edit: !!vault.can_edit,
        can_delete: !!vault.can_delete,
        can_manage_details: !!vault.can_manage_details,
        can_manage_permissions: !!vault.can_manage_permissions,
        active_secure_share: vault.active_secure_share || null,
        updated_at: vault.updated_at || currentVault.updated_at || null,
        last_access_at: vault.last_access_at || currentVault.last_access_at || null,
    };
}

export function resolveVaultAvatar(user) {
    if (!user) {
        return '';
    }

    if (user.avatar && user.avatar !== 'gravatar') {
        return user.avatar;
    }

    return user.gravatar || '';
}

export function buildVaultReleaseUsers(collection = []) {
    const recipients = [];
    const seenIds = new Set();

    (Array.isArray(collection) ? collection : []).forEach((person) => {
        const id = Number(person && person.id ? person.id : 0);
        if (!id || seenIds.has(id)) {
            return;
        }

        seenIds.add(id);
        recipients.push({
            id,
            name: person && person.name ? person.name : '-',
            email: person && person.email ? person.email : '',
            avatar: resolveVaultAvatar(person),
        });
    });

    return recipients;
}

export function formatVaultDateTime(value) {
    if (!value) {
        return '-';
    }

    return window.moment(value).format('DD.MM.YYYY HH:mm');
}

export function resolveVaultHistoryAccessType(entry) {
    return entry && entry.kind === 'change'
        ? 'Schreibzugriff'
        : 'Lesezugriff';
}
